import { activeCompanyStore } from './active-company-store';

// Triggers a download by fetching with credentials + the X-Company-Id header
// (anchors can't send custom headers), then streaming the response blob into
// a synthetic <a download>.
export async function downloadWithCompanyHeader(
  url: string,
  filename: string,
): Promise<void> {
  const companyId = activeCompanyStore.get();
  if (!companyId) return;
  const res = await fetch(url, {
    credentials: 'include',
    headers: { 'X-Company-Id': String(companyId) },
  });
  if (!res.ok) {
    throw new Error(`Download failed: ${res.status}`);
  }
  saveBlob(await res.blob(), filename);
}

/** Hands bytes already in memory to the browser as a file download. */
export function saveBlob(blob: Blob, filename: string): void {
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objectUrl);
}
